var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.0406395,8 L0.143682332,2.19156233 C-0.0478941105,2.00286165 -0.0478941105,1.6969174 0.143682332,1.50821673 L1.53120167,0.141525509 C1.72277811,-0.0471751698 2.03338489,-0.0471751698 2.22496133,0.141525509 L9.85631767,7.6583272 C10.0478941,7.84702788 10.0478941,8.15297212 9.85631767,8.3416728 L2.22496133,15.8584745 C2.03338489,16.0471752 1.72277811,16.0471752 1.53120167,15.8584745 L0.143682332,14.4917833 C-0.0478941105,14.3030826 -0.0478941105,13.9971383 0.143682332,13.8084377 L6.0406395,8 Z",
    id: "path-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.e9bd10df02e84ea48298187a677e25ae.svg";
export { ForwardRef as ReactComponent };